import React from 'react';
import ChatOptions from './ChatOptions';

const InlineOptions = ({ isPast, options, isLoading, ...chatOptionsProps }) => {
  const filteredOptions = options?.filter(o => o.optionType !== 'MAIN_MENU') || [];
  if (filteredOptions.length === 0) return null;
  return (
    <div className={`chat-inline-options ${isPast ? 'chat-inline-options--past' : ''}`}>
      <ChatOptions {...chatOptionsProps} options={filteredOptions} isInline isPast={isPast} isLoading={isPast ? false : isLoading} />
    </div>
  );
};

export default InlineOptions;
